import { BsArrowRightCircleFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { users } from "../../reducers/userReducer";
import { Link } from "react-router-dom";

export default function UserInfo() {
  const [username, setUsername] = useState("");
  const dispatch = useDispatch();
  return (
    <div className="user">
      <h2>What name should we call you?</h2>
      <div className="d-flex w-100 justify-content-between whats align-items-center">
        <input
          type="text"
          className="what"
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
          }}
        />
        <Link to='/userIntro'>
          <BsArrowRightCircleFill
            size="40px"
            className="mx-3 arrow"
            onClick={() => {
              dispatch(users(username));
            }}
          />
        </Link>
      </div>
    </div>
  );
}
